import { render, staticRenderFns } from "./medicalCare.vue?vue&type=template&id=7f611524&scoped=true&"
import script from "./medicalCare.vue?vue&type=script&lang=js&"
export * from "./medicalCare.vue?vue&type=script&lang=js&"
import style0 from "./medicalCare.vue?vue&type=style&index=0&id=7f611524&prod&lang=scss&scoped=true&"
import style1 from "./medicalCare.vue?vue&type=style&index=1&id=7f611524&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f611524",
  null
  
)

export default component.exports